<div class="input-group add-on ch-header-item" style="display: inline-block; width: 200px;">
  <input
    class="form-control"
    placeholder="Search..."
    name="srch-term"
    id="srch-term"
    type="text"
    style="width:150px"
    value="{{ value }}"
    #searchInput
    (keyup.enter)="submit(searchInput.value)"
  />
  <div id='searchInputGo' class="input-group-btn"><button class="btn btn-default" type="submit" (click)="submit(searchInput.value)">Go!</button></div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/search-input/search-input.component.html